<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!--   <div class="personal-details">
          <h4 class="personal-details-title">Raw Material List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Code</th>
                <th scope="col">Price</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let offer of cProductList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{offer.name}}</th>
                <th scope="col">{{offer.code}}</th>
                <th scope="col">{{offer.price}}</th>
                <th scope="col">
                  <i class="bi bi-eye-fill" (click)="getCproductMasterById(offer.cproductId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="cProductList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>-->


      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <p>Raw Material List</p>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="search" (keyup.enter)="getCProductByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
              </form>
              <i class="bi bi-search" (click)="getCProductByWildSearch()" style="cursor: pointer;"></i>
            </div>
            <button *ngIf="actionControls.isAdd" (click)="openAdd()" data-toggle="modal" data-target="#addModal"><i
                class="bi bi-plus-lg"></i> Add</button>
            <div class="filter-icon">
                <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 30%">Name</th>
              <th style="width: 30%">Code</th>
              <th style="width: 20%">Price</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" (click)="onRowClick($event, offer.cProductId)" *ngFor="let offer of cProductList | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count};let i = index">
            <p style="width: 30%">{{offer.name}}</p>
            <p style="width: 30%">{{offer.code}}</p>
            <p style="width: 20%">{{offer.price}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
              <i *ngIf="actionControls.isModify" class="bi bi-pencil-square"
                (click)="getCproductMasterById(offer.cProductId)" data-toggle="modal" data-target="#edit"></i>
              <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getCproductMasterById(offer.cProductId)"
                data-toggle="modal" data-target="#exampleModalView"></i>
              <i *ngIf="actionControls.isDelete" class="bi bi-trash3" (click)="deleteCproduct(offer.id)"
                data-toggle="modal" data-target="#deleteModal"></i>

            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && cProductList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>
        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" id="openViewModalBtn" data-toggle="modal" data-target="#exampleModalView" style="display: none;"></button>
<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Material Data
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let product of singleCproductMasterData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Name</label>
                <input type="text" readonly value="{{product.name}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Group</label>
                <input type="text" readonly value="{{product.group}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Price</label>
                <input type="text" readonly value="{{product.price}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Code</label>
                <input type="text" readonly value="{{product.code}}" class="form-control">
              </div>
            </div>
          </div>

          <div class="row" *ngIf="product.supportedUOM && product.supportedUOM.length > 0">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>UOM Name</label>
                <input type="text" readonly value="{{product.supportedUOM[0].uomName}}" class="form-control">
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteCproductMaster()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Raw Material
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name <span class="required-field">*</span></label>
                <input formControlName="name" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group <span class="required-field">*</span></label>
                <input formControlName="group" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Code <span class="required-field">*</span></label>
                <input formControlName="code" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Price <span class="required-field">*</span></label>
                <input formControlName="price" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30"
                  rows="3"></textarea>
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Select UOM <span class="required-field">*</span></label>
                <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedUomId">
                  <option [ngValue]="''" disabled selected hidden>-- select uom --</option>
                  <option *ngFor="let uom of uomDropdownList" [ngValue]="uom.uomMasterId">{{uom.uomName}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeAdd" class="btn btn-secondary" data-dismiss="modal">Cancel</button>

        <button type="button" (click)="addCProduct()" class="btn btn-primary">Submit</button>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="edit" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Product Data
          <span data-dismiss="modal">
            <i data-dismiss="modal" id="closeEdit" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name <span class="required-field">*</span></label>
                <input formControlName="name" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group <span class="required-field">*</span></label>
                <input formControlName="group" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Code <span class="required-field">*</span></label>
                <input formControlName="code" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Price <span class="required-field">*</span></label>
                <input formControlName="price" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30"
                  rows="3"></textarea>
              </div>
            </div>


            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Select UOM <span class="required-field">*</span></label>
                <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedUomId">
                  <option [ngValue]="''" disabled selected hidden>-- select uom --</option>
                  <option *ngFor="let uom of uomDropdownList" [ngValue]="uom.uomMasterId">{{uom.uomName}}</option>
                </select>
              </div>
            </div>


            <div class="col-md-12 col-lg-12 submit-b">
              <button class="btn btn-primary" *ngIf="!addButton" (click)="editCProduct()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>